import { TwcProduct } from '../../../twc-products';

export const HIGH_ICE_WATER_PRODUCT_DATA: TwcProduct = {
  id: 'high-ice-water-content',
  defaultProductId: 'highIceWaterContent-boeing',
  productName: 'Weather-High-Ice-Water-TWC',
  label: 'High Ice Water Content',
  weatherType: 'HIGH_ICE_WATER',
  description:
    'TWC product (raster, forecast) - Global High Ice Water Content (HIWC) Forecast',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 60,
  flightLevelProductIds: {},
  zOrder: 85
};
